import React from 'react';
import { ReactComponent as IconClose } from 'static/ic-close.svg';
import { selectIsModalOpened } from 'state/selectors';
import { useModal } from 'useCase/modal/useModal';
import {
    ModalWrapper,
    ModalBody,
    ModalClose,
    ModalContainer,
    ModalFooter,
    ModalHeader,
    ModalHeaderContent,
} from './view';

type ModalProps = {
    header?: React.ReactNode;
    children?: React.ReactNode;
    footer?: React.ReactNode;
};

export const Modal = ({ header, children, footer }: ModalProps) => {
    const { closeModal } = useModal();
    const isOpen = selectIsModalOpened();

    return (
        <ModalWrapper opened={isOpen}>
            <ModalContainer>
                <ModalHeader>
                    <ModalHeaderContent>{header}</ModalHeaderContent>
                    <ModalClose onClick={() => closeModal()}>
                        <IconClose />
                    </ModalClose>
                </ModalHeader>
                <ModalBody>{children}</ModalBody>
                <ModalFooter>{footer}</ModalFooter>
            </ModalContainer>
        </ModalWrapper>
    );
};
